import { OverallPage } from './OverallPage'
import { withOverallPage } from './withOverallPage'

const ConnectedOverallPage = withOverallPage(OverallPage)

export { ConnectedOverallPage as OverallPage }
